/**
 * Luminancia relativa (fórmula WCAG) para decidir si un color de fondo necesita
 * texto claro u oscuro encima. Umbral 0.6: por debajo se considera fondo oscuro/
 * saturado (texto claro); por encima, fondo claro (texto oscuro) — caso real: el
 * amarillo de FOSE (#EAB308) necesita texto oscuro, a diferencia del resto de la paleta.
 */
export function getContrastTextColor(hexColor: string): 'light' | 'dark' {
  const normalizedHex = hexColor.replace('#', '');
  const red = parseInt(normalizedHex.substring(0, 2), 16) / 255;
  const green = parseInt(normalizedHex.substring(2, 4), 16) / 255;
  const blue = parseInt(normalizedHex.substring(4, 6), 16) / 255;
  const relativeLuminance = 0.2126 * red + 0.7152 * green + 0.0722 * blue;
  return relativeLuminance > 0.6 ? 'dark' : 'light';
}
